import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import './App.css';
import Home from "./Pages/Home/Home";
import AboutUs from "./Pages/AboutUs";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndCondition from "./Pages/TermsAndCondition";
import Price from "./Pages/Price";
const Layout  = lazy(() => import("./Components/Layout/Layout"))
const Spinnerr = lazy(() => import("./Components/Spinner/Spinner"));

function ScrollToHash() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const timer = setTimeout(() => {
      const target = document.getElementById(hash.slice(1));
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);

    return () => clearTimeout(timer);
  }, [hash]);

  return null;
}

function App() {
  return (
    <Suspense fallback={<Spinnerr/>}>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Layout />} >
            <Route index element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-condition" element={<TermsAndCondition />} />
            <Route path="/price" element={<Price />} />
            <Route path="subscription/success" element={<Home />} />
            <Route path="subscription/success/:sessionId" element={<Home />} />
            <Route path="subscription/cancel" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
